import { IUser } from './user';

export interface IUserResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            user: IUser,
            failureCode: number
        }
    }
}

export interface IProfileResponse {
    data: {
        success: boolean;
        message: string;
        results: IUser;
    }
}